import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  Maintenance,
  MaintenanceData,
  MaintenanceHistoryRequest,
  MaintenanceSearchRequest,
  MaintenanceSearchResponse,
  MaintenanceStats,
} from "./@types";

export const maintenanceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMaintenances: builder.mutation<
      ApiSuccessResponse<MaintenanceSearchResponse>,
      MaintenanceSearchRequest
    >({
      query: (data) => ({
        url: "/v1/maintenance/search",
        method: "POST",
        body: { ...data },
      }),
    }),
    getMaintenanceHistory: builder.mutation<
      ApiSuccessResponse<MaintenanceSearchResponse>,
      MaintenanceHistoryRequest
    >({
      query: (data) => ({
        url: "/v1/maintenance/vehicle/history",
        method: "POST",
        body: { ...data },
      }),
    }),
    getMaintenanceStats: builder.query<
      ApiSuccessResponse<MaintenanceStats>,
      void
    >({
      query: () => ({
        url: "/v1/maintenance/stat",
        method: "GET",
      }),
    }),
    addMaintenance: builder.mutation<
      ApiSuccessResponse<MaintenanceData>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/maintenance",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateMaintenance: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: `/v1/maintenance/update${data.id}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
    getMaintenanceById: builder.query<ApiSuccessResponse<Maintenance>, string>({
      query: (id) => ({
        url: `/v1/maintenance/getmaintenance/${id}`,
        method: "GET",
      }),
    }),
    deleteMaintenance: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/maintenance/delete${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetMaintenancesMutation,
  useGetMaintenanceHistoryMutation,
  useGetMaintenanceStatsQuery,
  useAddMaintenanceMutation,
  useUpdateMaintenanceMutation,
  useGetMaintenanceByIdQuery,
  useDeleteMaintenanceMutation,
} = maintenanceApiSlice;
